import React, { Component } from "react";

// Components
import RegisteredReviewerItem from "./RegisteredReviewerItem";

// CSS
import "../../../../css/forms/confirmed-reviewers.css";

class ConfirmedReviewers extends Component {
	render() {
		const { review, role } = this.props;

		return (
			<div className="confirmed-reviewers pt1">
				<div className="confirmed-reviewers--col">
					<h3>On Site</h3>
					<div className="confirmed-reviewers--collection">
						{review.reviewers.on_site.length ? (
							review.reviewers.on_site.map((reviewer, i) => (
								<RegisteredReviewerItem
									key={i}
									reviewer={reviewer}
									buttons={[
										role === 'manager' ? <React.Fragment></React.Fragment> 
										: <div
											key="del"
											className="icon-cross"
											onClick={() =>
												this.props.handleDelete(reviewer, "on_site")
											}
										/>
									]}
								/>
							))
						) : (
							<div className="">No reviewers approved</div>
						)}
					</div>
				</div>
				<div className="confirmed-reviewers--col">
					<h3>Reading</h3>
					<div className="confirmed-reviewers--collection">
						{review.reviewers.reading.length ? (
							review.reviewers.reading.map((reviewer, i) => (
								<RegisteredReviewerItem
									key={i}
									reviewer={reviewer}
									buttons={[
										role === 'manager' ? <React.Fragment></React.Fragment> 
										: <div
											key="del"
											className="icon-cross"
											onClick={() =>
												this.props.handleDelete(reviewer, "reading")
											}
										/>
									]}
								/>
							))
						) : (
							<div className="">No reviewers approved</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default ConfirmedReviewers;



// WEBPACK FOOTER //
// ./src/components/admin/reviews/form-components/ConfirmedReviewers.js